// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"99b27b00","217":"96cd9e3e","223":"b50a2774","247":"092ac2c6","291":"c1eac4b7","332":"6c477849","468":"0770d814","515":"9e15e741","761":"88c723a6"}[chunkId] + ".chunk.js";
};